import SourceRole from 'sources/sourceTypes/Role';
import Role from 'types/Role';

export const toSource = (_obj: Role): SourceRole => {
  return new SourceRole();
};

export const toType = (sourceObj: SourceRole): Role => {
  const role = new Role();

  role.id = sourceObj.role_id;
  role.customerId = sourceObj.customer_id;
  role.customerName = sourceObj.customer_name;
  role.type = sourceObj.role_type;

  return role;
};
